import { ErrorMessage, Field, Form, Formik } from "formik";
import postData from "../services/postData";
import Modal from "./Modal";
import { useState } from "react";
import { ScrollToFieldError } from "./formik/ScrollToFieldError";
import { formSchema } from "../schema/formSchema";
import SkodaSecondDataInfo from "./SkodaSecondDataInfo";
import SkodaDataInfo from "./SkodaDataInfo";

export default function ServiceForm({ setLoadingSpinnerOpen, setSuccess }) {
    const formType = "newsletter,nowy,kampania,2025";

    const [failureModal, setFailureModal] = useState(false);
    const [formIsSubmitting, setFormIsSubmitting] = useState(false);
    const [showDisclaimer, setShowDisclaimer] = useState(false);

    const dataLayerPush = (orderId) => {
        try {
            window.dataLayer.push({
                event: "formularze",
                "wypelniony-formularz": "newsletter-zamowiono",
                orderid: orderId,
            });
            console.log("dataLayer.push ok:", orderId);
        } catch (err) {
            console.error("dataLayer.push error:", err);
        }
    };

    const syneriseSendFormData = (orderId, values) => {
        if (!("SR" in window)) {
            console.error("SR undefined");
            return;
        }

        const snrData = {
            orderID: orderId,
            firstname: values.firstName, //imie
            email: values.email, //email
            newsletterAgreement: values.newsletterAgreement
                ? "enabled"
                : "disabled",
            newsletter_info: values.newsletter_info,
            statute: values.statute,
        };
        try {
            window.SR.event
                .sendFormData(formType, snrData)
                .then((res) => {
                    console.log(formType);
                    console.log(res);
                })
                .catch((err) => {
                    console.log(formType);
                    console.error(err);
                });
        } catch (err) {
            console.error("SR error", err);
        }
    };

    return (
        <Formik
            initialValues={{
                firstName: "",
                email: "",
                newsletterAgreement: false,
                newsletter_info: false,
                statute: false,
            }}
            validationSchema={formSchema}
            onSubmit={(values, actions) => {
                actions.setSubmitting(false);
                setFormIsSubmitting(true);
                // console.log(values);
                // setLoadingSpinnerOpen(true);

                values["formType"] = formType;

                postData(values)
                    .then((data) => {
                        if (data && data.status === "ok") {
                            dataLayerPush(data.orderId);
                            syneriseSendFormData(data.orderId, values);
                            actions.resetForm();
                            setSuccess(true);
                        } else {
                            setFailureModal(true);
                        }
                    })
                    .catch((error) => {
                        setFailureModal(true);
                        console.error("error", error);
                    })
                    .finally(() => {
                        setFormIsSubmitting(false);
                        // setLoadingSpinnerOpen(false);
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "smooth",
                        });
                    });
            }}
        >
            {(formikProps) => (
                <>
                    <Modal open={failureModal} setOpen={setFailureModal}>
                        Wystąpił błąd!
                        <br />
                        Prosimy spróbować później.
                    </Modal>

                    <Form
                        className="form-container form-container js-subscribe-form"
                        method={`post`}
                    >
                        <ScrollToFieldError />
                        <div className="form-row">
                            <div className="form-copy">
                                <b>
                                    <h2>
                                        Dołącz do czytelników „Škoda Puls” -
                                        nowego magazynu motoryzacyjnego
                                    </h2>
                                </b>
                                <p>
                                    Motoryzacja jest Twoją pasją? Naszą też!
                                    „Škoda Puls" to unikatowe treści ze świata
                                    marki dostarczane raz w miesiącu na Twoją
                                    skrzynkę e-mailową. Zapisując się, zyskasz
                                    dostęp do:
                                    <ul>
                                        <li>premier nowych modeli Škody,</li>
                                        <li>
                                            testów wyjątkowych samochodów marki
                                            Škoda,
                                        </li>
                                        <li>informacji o wydarzeniach,</li>
                                        <li>
                                            informacji o ofertach i okresach
                                            promocyjnych.
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                        <div className="form-row">
                            <label className="form-label" htmlFor="firstName">
                                Imię
                            </label>
                            <Field
                                id="firstName"
                                name="firstName"
                                type="text"
                                className="form-input"
                                maxLength={50}
                            ></Field>
                            <ErrorMessage name="firstName">
                                {(msg) => (
                                    <div className="form-error">{msg}</div>
                                )}
                            </ErrorMessage>
                        </div>
                        <div className="form-row">
                            <label className="form-label" htmlFor="email">
                                Adres - email*
                            </label>
                            <Field
                                id="email"
                                name="email"
                                type="email"
                                className="form-input"
                                maxLength={255}
                            ></Field>
                            <ErrorMessage name="email">
                                {(msg) => (
                                    <div className="form-error">{msg}</div>
                                )}
                            </ErrorMessage>
                        </div>
                        {/*<div style={{paddingBottom: "10px"}}>&nbsp;</div>*/}
                        <br />
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field
                                    className="form-check-input"
                                    id="newsletterAgreement"
                                    name="newsletterAgreement"
                                    type="checkbox"
                                ></Field>
                                <label
                                    htmlFor="newsletterAgreement"
                                    className="form-check-label"
                                >
                                    Chcę otrzymywać Newsletter od Volkswagen
                                    Group Polska Sp. z o.o. z wykorzystaniem
                                    adresu e-mail oraz pozostałych podanych
                                    przeze mnie Danych.{" "}
                                </label>
                            </div>
                            <ErrorMessage name="newsletterAgreement">
                                {(msg) => (
                                    <div className="form-error">{msg}</div>
                                )}
                            </ErrorMessage>
                        </div>
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field
                                    className="form-check-input"
                                    id="newsletter_info"
                                    name="newsletter_info"
                                    type="checkbox"
                                ></Field>
                                <label
                                    htmlFor="newsletter_info"
                                    className="form-check-label"
                                >
                                    W ramach Newslettera zgadzam się na
                                    otrzymywanie od Volkswagen Group Polska Sp.
                                    z o.o. w/w informacji mogących stanowić
                                    informacje handlowe i marketingowe.{" "}
                                </label>
                            </div>
                            <ErrorMessage name="newsletter_info">
                                {(msg) => (
                                    <div className="form-error">{msg}</div>
                                )}
                            </ErrorMessage>
                        </div>
                        <div className="form-row">
                            <div className="form-checkbox">
                                <Field
                                    className="form-check-input"
                                    id="statute"
                                    name="statute"
                                    type="checkbox"
                                ></Field>
                                <label
                                    htmlFor="statute"
                                    className="form-check-label"
                                >
                                    Akceptuję{" "}
                                    <a
                                        href="https://twoja.skoda.pl/brandportal/newsletter/rules/0afc6cb8156bd43640a6a5f47d5f655f4c45c2b1.pdf"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        regulamin
                                    </a>
                                </label>
                            </div>
                            <ErrorMessage name="statute">
                                {(msg) => (
                                    <div className="form-error">{msg}</div>
                                )}
                            </ErrorMessage>
                        </div>
                        <SkodaSecondDataInfo />
                        <SkodaDataInfo />
                        <br />
                        <div className="form-row form-row--buttons">
                            <button
                                type="submit"
                                className="button button--primary"
                                disabled={formIsSubmitting}
                            >
                                Zapisz
                            </button>
                        </div>
                    </Form>
                </>
            )}
        </Formik>
    );
}
